import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { createSelector } from '@reduxjs/toolkit';
import { getContestDetailThunk as onGetContestDetailThunk } from "../../slices/contest/thunk";
import { Header } from '../../components/header/Header';
import { SketchDetails } from '../../components/sketch_details/SketchDetails';
import RecomendedArtist from '../users/RecomendedArtist';

import { saveContestPublishStatusThunk as saveContestPublishStatusThunkApi } from '../../slices/contest/thunk';
import AvailableArtist from '../users/AvailableArtist';

const ArtistContestEventRequest = () => {

  const dispatch = useDispatch();
  const [contestDetail, setContestDetail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const {contestId } = useParams();
  const navigate=useNavigate();

  const selectContestState = (state) => state.contest;
  const contestSelector = createSelector(selectContestState, (contest) => ({

    contestList: contest.contestList,
    isContestPublish: contest.isContestPublish,

  }));

  const { contestList,isContestPublish } = useSelector(contestSelector);
  const [sketchData, setSketchData] = useState({
    name: "",
    description: "",
    media: [],
  });

  useEffect(() => {
    dispatch(onGetContestDetailThunk({ contestId:contestId }));
  }, [dispatch, contestId]);

  // Store contestList in state
  useEffect(() => {
    if (contestList && contestList.id) {
      setContestDetail(contestList);
    }
  }, [contestList]);

    useEffect(() => {
    if (isContestPublish) {
      setIsLoading(false);
      // navigate('/user/my-contests')
    }
  }, [isContestPublish,navigate]);

  // Set sketch data and parse countdown
  useEffect(() => {
    if (contestDetail && contestDetail.id) {
      // console.log("contestDetail");
      // console.log(contestDetail);
      setSketchData({
        id: contestDetail.id || null,
        timeLeft: contestDetail.timeLeft || 0,
        name: contestDetail.contestCategory || null,
        description: contestDetail.contestDescription || "",
        media: contestDetail.contestMedia || [],
      });
    }
  }, [contestDetail]);

  const createContest=()=>{

    setIsLoading(true);
    const formData = new FormData();
    formData.append("contest_id",contestId);
    formData.append("is_publish",1);    
    dispatch(saveContestPublishStatusThunkApi(formData));
    
  }


  return (
  <>
    <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color ">
          <Header title={"Contest"} showBack={true} />
        </header>

        <div className="w-full bg-[#F7F7F7]">
        <div className="w-full  mx-auto flex flex-col items-start justify-center gap-12 lg:flex-row mt-4">
   <div className="w-full lg:w-[40%] flex">
            <SketchDetails
              name={sketchData.name}
              description={sketchData.description}
              sketchMedia={sketchData.media}
              isShowDetail={1}
             sketchData={sketchData}
             contestData={contestDetail}


            />
          </div>
             <div className="cursor-pointer w-full lg:w-[60%] h-full flex flex-col items-center justify-start border  border-border_color rounded-[14px]">
            <div className='w-full p-4 sm:p-6'>
              <div className=' flex items-center justify-between'>
                <div><span className='font-bold font-grotesk sm:text-xl text-sm text-gray-800'>Select Artist</span></div>
                <div>
                 { isContestPublish == false ? ( <button 
                    className='bg-primary text-white rounded-xl px-2 sm:px-5 py-2 sm:py-3 font-grotesk font-medium sm:text-lg' 
                    onClick={()=>createContest()}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <div className="flex items-center justify-center">
                        <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                      </div>
                    ) : (
                      "Publish"
                    )}
                  </button>
                 ): ('')}
                </div>
              </div>
              {/* <div className='w-full flex items-center justify-center mt-8'><span className='font-bold font-grotesk text-sm text-gray-800'>  OR</span></div> */}
            </div>
           {contestDetail && (
  <AvailableArtist 
    contestId={contestId} 
    participants={contestDetail.participants} 
  />
)}
            </div>
        </div>
         </div>
  </>
  )
}

export default ArtistContestEventRequest